let memoryData = [
  {
    order: [1, 3, 4],
    interval: 500,
    correctAudio: "round2/vo_correct1"
  },
  {
    order: [1, 4, 2, 3],
    interval: 500,
    correctAudio: "round2/vo_correct2"
  },
  {
    order: [4, 2, 3, 4, 1],
    interval: 500,
    correctAudio: "round2/vo_correct6"
  }
]

export {memoryData}
